import { useAuth } from "../../state/hooks";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";
import { EmailCard } from "./EmailCard";
import { NameCard } from "./NameCard";
import { PasswordCard } from "./PasswordCard";

export const PersonalSettingsPage = () => {
  const { user } = useAuth();
  useDocumentTitle("Personal", "Settings");

  return (
    <div className="mx-auto w-full max-w-xl space-y-4xl">
      <NameCard account={user} />
      <EmailCard account={user} />
      <PasswordCard />
    </div>
  );
};
